import React, {useEffect, useState} from 'react';
import {useRouter} from 'next/router';
import dynamic from 'next/dynamic';
import Cookies from 'js-cookie';

import {useApp} from '@context/AppProvider';
import Listing from '@components/product/list';
import styles from '@styles/listing.module.scss';
import SeoMeta from '@components/common/seo';
import {api} from '@utils/api';
const AgeValidatorModal = dynamic(() => import('@models/ageValidator.modal'));
import Loading from '@components/Loading';
import {ageVerified} from '@utils/functions';

function ProductList(props) {
	const router = useRouter();
	const {
		idb: {isoCode, showRegisterPop},
		setIdb,
	} = useApp();

	const [data, setData] = useState({
		isModalShow: false,
		listLoadProduct: false,
		is18Plus: null,
		isoCode: null,
		showRegisterPop: false,
	});

	const {slug, ...filters} = router.query;

	let category = null;
	const title = props.category
		? props.category.Name || `Favourite's`
		: `Favourite's`;
	if (slug && slug.length === 1) {
		category = slug[0];
	}

	// Load Product condition with alochol category

	useEffect(() => {
		const init = () => {
			let obj = {};
			if (isoCode.toLowerCase() === 'nz' && props.is18Plus) {
				obj = {
					isModalShow: true,
					listLoadProduct: true,
					is18Plus: props.is18Plus,
				};
			} else {
				obj = {
					isModalShow: false,
					listLoadProduct: true,
					is18Plus: props.is18Plus,
				};
			}
			setData(preState => ({
				...preState,
				...obj,
			}));
		};

		if (isoCode && !data.listLoadProduct && !showRegisterPop) {
			init();
		}
	}, [isoCode, props.is18Plus, data.listLoadProduct, showRegisterPop]);

	useEffect(() => {
		if (data.is18Plus !== null && props.is18Plus !== data.is18Plus) {
			setData(preState => ({
				...preState,
				listLoadProduct: false,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.is18Plus, router.asPath]);

	useEffect(() => {
		if (
			isoCode !== null &&
			!Cookies.get('isoCode') &&
			isoCode.toLowerCase() !== data?.isoCode?.toLowerCase()
		) {
			setData(preState => ({
				...preState,
				listLoadProduct: false,
				isoCode: isoCode,
			}));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [isoCode]);

	useEffect(() => {
		if (showRegisterPop && isoCode) {
			let obj = {};
			if (isoCode.toLowerCase() === 'nz' && !ageVerified()) {
				setTimeout(() => {
					setIdb(val => ({...val, showRegisterPop: false}));
				}, 3000);
				obj = {
					showRegisterPop: true,
				};
			} else {
				obj = {
					isModalShow: false,
					listLoadProduct: true,
				};
			}
			setData(preState => ({
				...preState,
				...obj,
			}));
		}
	}, [data.listLoadProduct, isoCode, setIdb, showRegisterPop]);

	if (!data.isModalShow && !data.listLoadProduct) {
		return <Loading />;
	}

	return (
		<div className={styles.listingPageBlock}>
			<SeoMeta
				title={`Shop ${title} | Online Shopping is Here | Better That`}
				url={router.asPath}
				description={`Bag your favourite ${title} products at Better That and give back to Good Causes with every purchase. It's shopping- but Better!`}
				keywords={`Shop ${title} wear`}
			/>
			<h1 style={{display: 'none'}}>{title}</h1>
			{data.listLoadProduct &&
				(data.isModalShow ? (
					<AgeValidatorModal
						callback={() => {
							if (data.showRegisterPop)
								setIdb(val => ({...val, showRegisterPop: true}));
							setData(preState => ({
								...preState,
								isModalShow: false,
								showRegisterPop: false,
							}));
						}}
					/>
				) : (
					<Listing
						styles={styles}
						filters={filters}
						category={category}
						banners={props.banners}
						landscapeBanner={props.landscapeBanner}
					/>
				))}
		</div>
	);
}

export async function getServerSideProps(ctx) {
	const {query} = ctx;
	const slug = query.slug && query.slug.length ? query.slug[0] : null;

	const props = {
		banners: {},
		landscapeBanner: {},
		is18Plus: false,
	};
	if (slug) {
		let category = await api({
			url: `/categories/fetch-category-ancestor/slug/${slug}`,
			method: 'GET',
		});

		for (let i = category.length; i > 0; i--) {
			let banner = category[i - 1].categoryBanner;
			if (
				!Object.keys(props.banners).length &&
				banner &&
				((banner.banner1 && banner.banner1.imageUrl) ||
					(banner.banner2 && banner.banner2.imageUrl) ||
					(banner.banner3 && banner.banner3.imageUrl))
			) {
				props.banners = banner;
			}
			let landScapeBanner = category[i - 1].landScapeBanner;
			if (
				!Object.keys(props.landscapeBanner).length &&
				landScapeBanner &&
				landScapeBanner &&
				landScapeBanner.imageUrl
			) {
				props.landscapeBanner = landScapeBanner;
			}
			let alcoholCat = category[i - 1].is_18Plus;
			if (alcoholCat && alcoholCat === true) {
				props.is18Plus = true;
			}
		}
		if (category.length) {
			let name = `${
				category.length === 1
					? category[0].Name
					: category[category.length - 1].Name
			}'s`;
			if (category.length > 1) {
				name += ' in ';
				category.splice(category.length - 1, 1);
				const parents = [];
				for (let i = 0; i < category.length; i++) {
					parents.push(category[i].Name);
				}
				name += parents.join(' - ');
			}

			props.category = {Name: name};
		}
	} else {
		props.category = {Name: query.name || ''};
	}

	return {
		props,
	};
}

ProductList.Layout = true;

export default ProductList;
